<template>
  <v-card class="border shadow1">
    <div class="tituloBox p-l-15">
      <div class="bg-red barraTitulo"></div>
      <h1 class="text-default font-size-18">
        <strong>Acesso</strong> ao Cadastro
      </h1>
    </div>
    <v-form v-model="valid" ref="formLogin">
      <v-layout row>
        <v-flex xs12>
          <v-text-field
            v-model="login.login"
            :label="$t('label.login')"
            :rules="validacao.campoObrigatorio"
            required
            v-on:keyup.13="logar"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field
            v-model.trim="login.Senha"
            label="Senha"
            type="password"
            :rules="validacao.campoObrigatorio"
            v-on:keyup.13="logar"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <br>Esqueci
          <a @click="dialogRecuperarSenha()" href="javascript:void(0)">minha senha</a>.
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 p-b-15 p-t-10>
          <v-btn large color="success" @click="logar()">Acessar Cadastro</v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="dialogCadastro" width="90%">
      <v-card>
        <v-card-title class="headline grey lighten-2">Cadastrar Usuário</v-card-title>
        <v-card-text>
          <v-form v-model="valid" lazy-validation ref="formCadastrador">
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.nome"
                  :label="$t('label.nome') + ' *' "
                  :rules="validacao.campoObrigatorio"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.email"
                  :label="$t('label.email') + ' *' "
                  :rules="validacao.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.login"
                  :label="$t('label.login') + ' *' "
                  :rules="validacao.campoObrigatorio"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.cpf"
                  :label="$t('label.cpf')+' *' "
                  v-mask="maskCpf"
                  :rules="validacao.cpf"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.secretariaId"
                  :items="listaSecretaria"
                  :label="$t('label.secretaria')+' *'"
                  item-text="descSecretaria"
                  item-value="codSecretaria"
                  :rules="validacao.campoObrigatorio"
                  @change="getComboUnidade(model.secretariaId)"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-autocomplete
                  v-model="model.unidadeId"
                  :items="listaUnidade"
                  :label="$t('label.unidade')+' *'"
                  item-text="descUnidade"
                  item-value="numUnidade"
                  :rules="validacao.campoObrigatorio"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="model.telefone"
                  :label="$t('label.telefone') + ' *' "
                  v-mask="maskTelefone"
                  :rules="validacao.campoObrigatorio"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  type="password"
                  v-model="model.senha"
                  :label="$t('label.senha')+' *'"
                  :rules="validacao.validAlphaNumericCaracter"
                  :hint="$t('messages.validacao.alphaNumericCaracter')"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  type="password"
                  v-model="repitaSenha"
                  :label="$t('label.repitaSenha')+' *'"
                  :rules="[validaSenhaIguais() || msgRepitaSenha]"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="cadastrarUsuario()">Criar usuário</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-form v-model="valid" ref="formEsqueciSenha">
    <v-dialog v-model="dialogEsqueciSenha" width="90%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Recuperar Senha</v-card-title>
          <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    v-model="model.email"
                    :label="$t('label.email')"
                    :rules="validacao.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="model.login"
                    :label="$t('label.login') "
                    :rules="validacao.campoObrigatorio"
                  ></v-text-field>
                </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="recuperarSenha()">Recuperar Senha</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <v-form v-model="validAlterar" lazy-validation ref="formAlterarSenha">
      <v-dialog v-model="dialogAlterarSenha" persistent width="90%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Nova senha</v-card-title>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-text-field type="password" v-model="alterar.senha" :label="$t('label.senha')+' *'" :rules="validacao.validAlphaNumericCaracter" :hint="$t('messages.validacao.alphaNumericCaracter')" persistent-hint required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field type="password" v-model="repitaSenha" :label="$t('label.repitaSenha')+' *'" :rules="[alterar.senha === repitaSenha || msgRepitaSenha]" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex xs3 sm3>
              <v-btn color="warning" @click="dialogAlterarSenha = false">Cancelar</v-btn>
            </v-flex>
            <v-flex xs3 sm3>
              <v-btn color="info" @click="alterarSenha()">Confirmar</v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-card>
</template>
<script>
import loginService from "../../../services/loginService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */

export default {
  name: "loginRestritoForm",
  mixins: [util],
  created() /*Metodo de start do componente*/{
    this.$store.commit("setToken", null);
    this.$store.commit("setTokenRefresh", null);
    this.getComboSecretaria();
  },
  beforeMount(){
    this.abrirModalSenha();
  },
  data() {//Declaracao de variaveis
    return {
      listaSecretaria: [],
      listaUnidade: [],
      dialogCadastro: false,
      dialogEsqueciSenha: false,
      dialogAlterarSenha: false,
      valid: false,
      validAlterar: false,
      login: {},
      model: {},
      alterar: {
        senha: ""
      },
      repitaSenha: "",
      msgRepitaSenha: this.$t("messages.validacao.senhasDiferentes")
    };
  },
  methods: {//Declaracao de todos os metodos
    getComboSecretaria() {
      loginService.getSecretarias().then(response => { /*resposta do servico*/
        this.listaSecretaria = response.data; /*dados de retorno*/
      });
    },
    getComboUnidade(secretariaId) {
      if (this.model.unidadeId) this.model.unidadeId = null;
      loginService.getUnidades(secretariaId).then(response => { /*resposta do servico*/
        this.listaUnidade = response.data; /*dados de retorno*/
      });
    },
    logar() {
      this.$store.commit("setAba", {
        abaAtiva: "tab-dados"
      });
      if (this.$refs.formLogin.validate()) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        loginService
          .loginRestrito(this.login)
          .then(response => { /*resposta do servico*/
            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

            switch (this.$store.getters.getPerfil) {
              case "cadastrador":
                this.$router.push("/arearestrita/cadastrador/solicitacao");
                break;
              case "validador":
                this.$router.push("/arearestrita/habilitador/dashboard");
                break;
              case "validadormaster":
                this.$router.push("/arearestrita/habilitador/dashboard");
                break;
              default:
                this.$toasted.error(
                  this.$t("messages.validacao.usuarioSemPermissao")
                );
                 break;
            }

            this.$removePreload(); /*Ocultar o PreLoad*/
          })
          .catch(() => {
            this.$removePreload(); /*Ocultar o PreLoad*/
          });
      }
    },
    dialogCadastrarUsuario() {
      this.dialogCadastro = true;
    },
    dialogRecuperarSenha() {
      this.dialogEsqueciSenha = true;
    },
    recuperarSenha() {
      if (this.$refs.formEsqueciSenha.validate()) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        const model = {login: this.model.login, email:this.model.email};
        loginService.recuperarSenhaServidor(model).then(response => { /*resposta do servico*/
          this.$toasted.success(response.data);
          this.$store.commit("setToken", "");
          this.$router.push("/loginrestrito");
          this.$removePreload(); /*Ocultar o PreLoad*/
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        });
        this.dialogEsqueciSenha = false;
      }
    },
    cadastrarUsuario() {
      if (this.$refs.formCadastrador.validate()) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        loginService
          .cadastrarUsuario(this.model)
          .then(response => { /*resposta do servico*/
            this.dialogCadastro = false;

            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

            this.$toasted.success(this.$t("messages.cadastro.sucesso"));
            this.$router.push("/arearestrita/cadastrador/solicitacao");
            this.$removePreload(); /*Ocultar o PreLoad*/
          })
          .catch(() => {
            this.$removePreload(); /*Ocultar o PreLoad*/
          });
      }
    },
    validaSenhaIguais() {
      if (this.model.senha !== this.repitaSenha) {
        if (!this.repitaSenha) {
          this.msgRepitaSenha = this.$t("messages.validacao.campoObrigatorio");
        } else {
          this.msgRepitaSenha = this.$t("messages.validacao.senhasDiferentes");
        }
        return false;
      }
      return true;
    },
    abrirModalSenha() {
      if(this.$route.query.codAtivacao && this.$route.query.address && this.$route.query.login){
        let model = {
            email: this.$route.query.address,
            codAtivacao: this.$route.query.codAtivacao,
            login: this.$route.query.login,
            id: 0
        }
        loginService.validarCodativacaoServidor(model).then(response => { /*resposta do servico*/
          this.$store.commit("setToken", null);
          this.$store.commit("setTokenRefresh", null);
          this.$removePreload(); /*Ocultar o PreLoad*/
          this.dialogAlterarSenha = true;
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
      }
    },
    alterarSenha() {
      if (this.$refs.formAlterarSenha.validate() && this.$route.query.address && this.$route.query.login) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        let model = {
          Email: this.$route.query.address,
          Senha: this.alterar.senha,
          Login: this.$route.query.login
        };
        loginService.alterarSenhaServidor(model).then(response => { /*resposta do servico*/
          this.$toasted.success(response.data);
          this.dialogAlterarSenha = false;
          this.$store.commit("setToken", null);
          this.$store.commit("setTokenRefresh", null);
          this.$router.push("/loginrestrito");
          this.$removePreload(); /*Ocultar o PreLoad*/
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
      }
    },
  }
};
</script>
